import { pmFetchJson } from "./pmFetch";

export type Facility = any;

const uniqByName = (items: any[]): any[] => {
  const seen = new Set<string>();
  const out: any[] = [];
  for (const item of items) {
    const name = item && typeof item.name === "string" ? item.name.trim() : "";
    if (!name) continue;
    const key = name.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(item);
  }
  return out;
};

export async function findFacility(args: {
  q: string;
  state: string;
  email: boolean;
}): Promise<Facility[]> {
  const res = await pmFetchJson<any>("/find-facility", {
    method: "GET",
    params: { q: args.q, state: args.state, email: args.email ? "true" : "false" },
  });

  const list = Array.isArray(res) ? res : [];
  return uniqByName(list);
}

